import {ConditionApiResponse} from '@/patient/interfaces/Condition';
import {useSharedDataContext} from '@/shared/components/layout/LoggedInLayout/contexts/SharedDataContext';
import useSuspenseApiQuery from '@/shared/hooks/useSuspenseApiQuery';
import mapResponseToCondition from '../utils/mapResponseToCondition';

const CONDITIONS = '/patient/conditions';

export function useConditions() {
  const {pathologiesById, bodySitesById} = useSharedDataContext();
  const {
    data: {data}
  } = useSuspenseApiQuery<ConditionApiResponse[]>({
    queryOptions: {
      queryKey: [CONDITIONS],
      staleTime: 0
    },
    requestArguments: {
      method: 'GET',
      path: CONDITIONS
    }
  });
  return data.map((c) =>
    mapResponseToCondition({
      condition: c,
      pathologiesById,
      bodySitesById
    })
  );
}

export function useAnalyzableConditions() {
  return useConditions().filter((c) => c.canBetracked);
}
